<template>
  <div class="container px-10">
    <img
      class="logo mb-2"
      src="@/assets/png/payscale-dark.png"
      alt="Datapeople icon"
    >
    <span class="p6 message">{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: 'WizardSmileSideBar',
  props: {
    message: {
      type: String,
      default: 'Bringing science to the hiring process',
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  min-height: inherit;
  background: url('../../assets/smile-side-bar.png');
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.logo {
  display: block;
  width: 240px;
  max-width: 100%;
}

.message {
  width: 125px;
  text-align: left;
  font-weight: 300;
  letter-spacing: 0.01em;
  color: @text-darkest;
}
</style>
